import { memo, useEffect, useState } from "react";
import {
  Box,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  Button,
  Menu,
  MenuButton,
  MenuList,
  Skeleton,
  MenuItem,
  Image,
  HStack,
  Img,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
} from "@chakra-ui/react";
import { formatTableValue } from "./formatTable";
import iconEdit from "../../assets/images/product/edit.svg";
import IconX from "../../assets/images/booking/x-circle.svg";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import ReactPaginate from "react-paginate";
import { AiOutlineMore } from "react-icons/ai";
import { useSaleOpeningEventMechanismParameters } from "../../hooks/useSaleOpeningEventMechanismParameters";
import iconButton from "../../assets/images/employee/icon-button.svg";
import TableUpdateProjectMechanism from "./tableUpdateProjectMechanism";
import TableUpdateProjectMechanismV1 from "./tableUpdateProjectMechanismV1";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { InputControl } from "../../components/form/formControls";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { saleOpeningEventMechanismParametersCall } from "../../api/saleOpeningEventMechanismParameters";
import { IoArrowBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import DeleteDialog from "../../components/dialog/delete";
import { saleOpeningEventCall } from "../../api/saleOpeningEvent";

const TableUpdate = ({ saleOpeningEventId }) => {
  const navigate = useNavigate();
  const {
    isOpen: isOpenTable,
    onOpen: onOpenTable,
    onClose: onCloseTable,
    onToggle: onToggleTable,
  } = useDisclosure();
  const {
    isOpen: isOpenOldTable,
    onOpen: onOpenOldTable,
    onClose: onCloseOldTable,
    onToggle: onToggleOldTable,
  } = useDisclosure();
  const {
    isOpen: isOpenTableDetail,
    onOpen: onOpenTableDetail,
    onClose: onCloseTableDetail,
    onToggle: onToggleTableDetail,
  } = useDisclosure();
  const {
    isOpen: isOpenOldTableDetail,
    onOpen: onOpenOldTableDetail,
    onClose: onCloseOldTableDetail,
    onToggle: onToggleOldTableDetail,
  } = useDisclosure();
  const {
    isOpen: isOpenDelete,
    onOpen: onOpenDelete,
    onClose: onCloseDelete,
    onToggle: onToggleDelete,
  } = useDisclosure();
  const {
    isOpen: isOpenHard,
    onOpen: onOpenHard,
    onClose: onCloseHard,
    onToggle: onToggleHard,
  } = useDisclosure();

  const [idEdit, setIdEdit] = useState();
  const [dataEdit, setDataEdit] = useState();
  const [saleOpeningEventData, setSaleOpeningEventData] = useState();

  const {
    saleOpeningEventMechanismParameterData,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useSaleOpeningEventMechanismParameters(saleOpeningEventId);

  const tableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "Hệ số k",
        key: "kRate",
      },
      {
        label: "Tỉ lệ nhận về (%)",
        key: "transactionRate",
      },
      {
        label: "Cơ chế chung (%)",
        key: "mechanismRateEliteCHUNG",
      },
      {
        label: "Cơ chế CVKD (%)",
        key: "mechanismRateEliteCVKD",
      },
      {
        label: "Loại",
        key: "statusKRate",
      },
      {
        label: "Note",
        key: "note",
      },
      {
        label: "Ngày tạo",
        key: "createdAt",
      },
    ],
    data: saleOpeningEventMechanismParameterData,
  };

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  const onOldTable = () => {
    onOpenOldTable();
  };

  const onTable = () => {
    onOpenTable();
  };

  const onTableDetail = (e) => {
    setIdEdit(e?.id);
    onOpenTableDetail();
  };

  const onOldTableDetail = (e) => {
    setIdEdit(e?.id);
    onOpenOldTableDetail();
  };

  const closeTableDetail = (e) => {
    setIdEdit(null);
    onCloseTableDetail();
  };

  const closeOldTableDetail = (e) => {
    setIdEdit(null);
    onCloseOldTableDetail();
  };

  const onDelete = (e) => {
    setDataEdit(e);
    onOpenDelete();
  };

  const closeDelete = (e) => {
    setDataEdit(null);
    onCloseDelete();
  };

  const onTableHard = (e) => {
    setIdEdit(e?.id);
    setDataEdit(e?.edit);
    onOpenHard();
  };

  const closeTableHard = () => {
    setIdEdit(null);
    setDataEdit(null);
    onCloseHard();
  };

  const fetchSaleOpeningEvent = async (id) => {
    try {
      const data = await saleOpeningEventCall.getId(id);
      setSaleOpeningEventData(data);
    } catch (error) {
      console.error("Error", error);
      toast.error("Có lỗi xảy ra khi lấy ra dự án");
    }
  };

  useEffect(() => {
    fetchSaleOpeningEvent(saleOpeningEventId);
  }, [saleOpeningEventId]);

  const submitHandlerCreate = async (data) => {
    const toastCreate = toast.loading("Đang thêm tính hệ số K ...");
    try {
      await saleOpeningEventMechanismParametersCall.create({
        ...data,
        statusKRate: 2,
      });

      await refetch();
      onToggleHard();
      onCloseHard();
      toast.success("Thêm tính hệ số K thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const submitHandlerUpdate = async (data) => {
    const toastCreate = toast.loading("Đang sửa tính hệ số K ...");
    try {
      await saleOpeningEventMechanismParametersCall.update(idEdit, {
        ...data,
        statusKRate: 2,
      });

      await refetch();
      onToggleHard();
      onCloseHard();
      toast.success("Sửa tính hệ số K thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const submitHandlerDelete = async (id) => {
    const toastCreate = toast.loading("Đang xóa hệ số K ...");
    try {
      await saleOpeningEventMechanismParametersCall.delete(id);

      await refetch();
      onToggleDelete();
      onCloseDelete();
      toast.success("Xóa hệ số K thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const handleNavigate = (e) => {
    navigate(`/open-for-sale`);
  };

  return (
    <>
      {!isOpenOldTable &&
        !isOpenTable &&
        !isOpenTableDetail &&
        !isOpenOldTableDetail && (
          <Box w={"full"}>
            <Flex
              onClick={handleNavigate}
              cursor={"pointer"}
              gap={"8px"}
              alignItems={"center"}
              mb={"24px"}
              w={"max-content"}
            >
              <IoArrowBackOutline fontSize={"24px"} />
              <Text
                fontSize={"20px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color={"var(--color-header-employee)"}
              >
                Quay lại
              </Text>
            </Flex>
            <Flex
              borderRadius={{ base: "12px" }}
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              mb={"24px"}
            >
              <Box>
                <Text
                  fontSize={"20px"}
                  lineHeight={"19px"}
                  fontWeight={"600"}
                  color={"var(--color-header-employee)"}
                  mb={"24px"}
                >
                  Đợt mở bán: {saleOpeningEventData?.name || ""}
                </Text>
                <Text
                  fontSize={"18px"}
                  lineHeight={"19px"}
                  fontWeight={"600"}
                  color={"var(--color-header-employee)"}
                >
                  Quản lý cơ chế tính hệ số K
                </Text>
              </Box>

              <Flex gap={4}>
                <Button
                  h={"44px"}
                  as={Button}
                  backgroundImage="var(--color-button)"
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                  _active={{
                    filter: "brightness(90%)",
                  }}
                  onClick={() => {
                    setIdEdit(null);
                    setDataEdit(null);
                    onOldTable();
                  }}
                >
                  <Flex
                    alignItems={"center"}
                    p={"10px 0px 10px 0px"}
                    gap={"8px"}
                  >
                    <Image src={iconButton} />
                    <Text
                      fontSize={{ base: "15px" }}
                      fontWeight={600}
                      color="var(--color-main)"
                    >
                      Thêm cơ chế cứng
                    </Text>
                  </Flex>
                </Button>
                <Button
                  h={"44px"}
                  as={Button}
                  backgroundImage="var(--color-button)"
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                  _active={{
                    filter: "brightness(90%)",
                  }}
                  onClick={() => {
                    setIdEdit(null);
                    setDataEdit(null);
                    onTable();
                  }}
                >
                  <Flex
                    alignItems={"center"}
                    p={"10px 0px 10px 0px"}
                    gap={"8px"}
                  >
                    <Image src={iconButton} />
                    <Text
                      fontSize={{ base: "15px" }}
                      fontWeight={600}
                      color="var(--color-main)"
                    >
                      Thêm cơ chế
                    </Text>
                  </Flex>
                </Button>
              </Flex>
            </Flex>

            <Flex flexDirection={"column"} gap={{ base: "16px" }} mb={"20px"}>
              <Flex
                backgroundColor="var(--color-main)"
                borderRadius={{ base: "12px" }}
                flexDirection={"column"}
              >
                <Box width={"100%"} height={"100%"}>
                  <Skeleton isLoaded={!isLoading && !isRefetching}>
                    <TableContainer
                      w={"100%"}
                      maxH="calc(100vh - 350.5px)"
                      overflowY="auto"
                    >
                      <Table w={"100%"} variant="unstyled">
                        <Thead
                          position="sticky"
                          top="0"
                          zIndex="1"
                          w={"100%"}
                          h={"41px"}
                          color="white"
                          fontWeight="400"
                          backgroundColor="#F9FAFD"
                        >
                          <Tr h={{ base: "41px" }}>
                            {tableData.headers.map((e, index) => {
                              let width = "auto";
                              let textAlign = "auto";
                              if (e.key === "") {
                                width = "2%";
                                textAlign = "center";
                              } else if (e.key === "code") {
                                width = "5%";
                                textAlign = "start";
                              } else if (e.key === "name") {
                                width = "10%";
                                textAlign = "start";
                              } else if (e.key === "project") {
                                width = "10%";
                                textAlign = "start";
                              } else if (e.key === "product") {
                                width = "10%";
                                textAlign = "start";
                              } else if (e.key === "price") {
                                width = "10%";
                                textAlign = "start";
                              } else {
                                width = "10%";
                                textAlign = "end";
                              }
                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  key={index}
                                  border={"none"}
                                  color={"#51607B"}
                                  fontSize={{ base: "14px" }}
                                  w={width}
                                >
                                  <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        </Thead>
                        <Tbody w={"100%"} h={"100%"}>
                          {tableData.data?.length > 0 ? (
                            tableData.data?.map((e, rowIndex) => {
                              const items = { ...e };
                              delete items.id;
                              delete items.saleOpeningEventId;
                              delete items.edit;
                              delete items.detail;
                              delete items.status;
                              delete items.isUsed;
                              const keyValues = Object.keys(items);
                              return (
                                <Tr key={rowIndex} h={"72px"}>
                                  <Td
                                    p={"16px 0px 8px 16px"}
                                    w={"2%"}
                                    bg={
                                      rowIndex % 2 === 0
                                        ? "var(--color-main)"
                                        : "var(--fill-avatar)"
                                    }
                                  >
                                    <Menu>
                                      <MenuButton
                                        _hover={{ backgroundColor: "none" }}
                                        _active={{ backgroundColor: "none" }}
                                        background="none"
                                        as={Button}
                                        p={0}
                                      >
                                        <AiOutlineMore
                                          fontSize={"20px"}
                                          w="20px"
                                        />
                                      </MenuButton>
                                      {/* {!e.isUsed && ( */}
                                      {
                                        <MenuList
                                          fontSize={{ base: "14px" }}
                                          fontWeight={500}
                                          lineHeight={"140%"}
                                          color={"var(--color-info-employee)"}
                                        >
                                          <MenuItem
                                            gap={"16px"}
                                            onClick={() => {
                                              // console.log(e)
                                              onOldTableDetail(e);
                                            }}
                                          >
                                            <Image src={iconEdit} /> Chỉnh sửa
                                            hệ số K cứng
                                          </MenuItem>
                                          <MenuItem
                                            gap={"16px"}
                                            onClick={() => {
                                              // console.log(e)
                                              onTableDetail(e);
                                            }}
                                          >
                                            <Image src={iconEdit} /> Chỉnh sửa
                                          </MenuItem>
                                          <MenuItem
                                            gap={"16px"}
                                            onClick={() => {
                                              onDelete(e);
                                            }}
                                          >
                                            <Image src={iconEdit} /> Xóa hệ số k
                                          </MenuItem>
                                        </MenuList>
                                      }
                                    </Menu>
                                  </Td>
                                  {keyValues.map((keyvalue, index) => {
                                    let width = "auto";
                                    let widthText = "100%";
                                    let textAlign = "auto";
                                    let whiteSpace = "inherit";
                                    if (keyvalue === "") {
                                      width = "2%";
                                      textAlign = "center";
                                    } else if (keyvalue === "code") {
                                      width = "5%";
                                      textAlign = "start";
                                    } else if (keyvalue === "name") {
                                      width = "10%";
                                      textAlign = "start";
                                    } else if (keyvalue === "project") {
                                      width = "10%";
                                      textAlign = "start";
                                      whiteSpace = "normal";
                                      widthText = "118px";
                                    } else if (keyvalue === "product") {
                                      width = "10%";
                                      textAlign = "start";
                                    } else if (keyvalue === "price") {
                                      width = "10%";
                                      textAlign = "start";
                                    } else {
                                      width = "10%";
                                      textAlign = "end";
                                      whiteSpace = "inherit";
                                    }
                                    return (
                                      <Td
                                        p={"16px 16px 8px 16px"}
                                        w={width}
                                        key={index}
                                        bg={
                                          rowIndex % 2 === 0
                                            ? "var(--color-main)"
                                            : "var(--fill-avatar)"
                                        }
                                      >
                                        <Box
                                          fontSize={{ base: "14px" }}
                                          lineHeight={"19.6px"}
                                          textAlign={"start"}
                                          fontWeight={500}
                                          color={"var(--color-info-employee)"}
                                          w={widthText}
                                          whiteSpace={whiteSpace}
                                          overflow="hidden"
                                          textOverflow="ellipsis"
                                          display="-webkit-box"
                                          sx={{
                                            WebkitLineClamp: "2",
                                            WebkitBoxOrient: "vertical",
                                          }}
                                        >
                                          {formatTableValue(
                                            e[keyvalue],
                                            keyvalue,
                                          )}
                                        </Box>
                                      </Td>
                                    );
                                  })}
                                </Tr>
                              );
                            })
                          ) : (
                            <Tr>
                              <Td
                                colSpan={tableData.headers.length}
                                textAlign="center"
                                padding={"40px 0"}
                              >
                                Không có dữ liệu
                              </Td>
                            </Tr>
                          )}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Skeleton>
                  <Box mt={10} mr={5} mb={5} ml={5}>
                    <Flex
                      alignItems={"center"}
                      justifyContent={"space-between"}
                    >
                      <Text>
                        Showing {startEntry} to {endEntry} of {entries} entries
                      </Text>
                      <HStack spacing={2} justify="flex-end">
                        <ReactPaginate
                          className="pagination-custom"
                          pageCount={totalPages}
                          pageRangeDisplayed={3}
                          marginPagesDisplayed={1}
                          onPageChange={handlePageChange}
                          containerClassName={"pagination"}
                          activeClassName={"active"}
                          breakClassName={"ellipsis"}
                          breakLabel={"..."}
                          previousLabel={
                            <Img
                              w={"16px"}
                              minW={"16px"}
                              h={"16px"}
                              src={chevronLeft}
                            />
                          }
                          nextLabel={
                            <Img
                              w={"16px"}
                              minW={"16px"}
                              h={"16px"}
                              src={chevronRight}
                            />
                          }
                          renderOnZeroPageCount={null}
                          forcePage={currentPage - 1}
                        />
                      </HStack>
                    </Flex>
                  </Box>
                </Box>
              </Flex>
            </Flex>
          </Box>
        )}

      {isOpenTable && (
        <TableUpdateProjectMechanism
          saleOpeningEventId={saleOpeningEventId}
          onClose={onCloseTable}
          onToggle={onToggleTable}
          refetch={refetch}
          name={saleOpeningEventData?.name}
        />
      )}

      {isOpenOldTable && (
        <TableUpdateProjectMechanismV1
          saleOpeningEventId={saleOpeningEventId}
          onClose={onCloseOldTable}
          onToggle={onToggleOldTable}
          refetch={refetch}
          name={saleOpeningEventData?.name}
        />
      )}

      {isOpenTableDetail && (
        <TableUpdateProjectMechanism
          saleOpeningEventId={saleOpeningEventId}
          onClose={closeTableDetail}
          onToggle={onToggleTableDetail}
          refetch={refetch}
          id={idEdit}
          name={saleOpeningEventData?.name}
        />
      )}

      {isOpenOldTableDetail && (
        <TableUpdateProjectMechanismV1
          saleOpeningEventId={saleOpeningEventId}
          onClose={closeOldTableDetail}
          onToggle={onToggleOldTableDetail}
          refetch={refetch}
          id={idEdit}
          name={saleOpeningEventData?.name}
        />
      )}

      <FormCreateKRateHard
        isOpen={isOpenHard}
        onClose={closeTableHard}
        defaultValues={{
          saleOpeningEventId: saleOpeningEventId,
          ...(dataEdit?.kRate && { kRate: dataEdit?.kRate }),
        }}
        onSubmit={dataEdit ? submitHandlerUpdate : submitHandlerCreate}
      />

      <DeleteDialog
        isOpen={isOpenDelete}
        onClose={closeDelete}
        title={"Xóa hệ số k"}
        description={
          <Flex display={"inline"}>
            Bạn có chắc chắn muốn hệ số k = {dataEdit?.kRate || ""}
          </Flex>
        }
        textDelete={"Xác nhận"}
        action={() => submitHandlerDelete(dataEdit?.id)}
      />
    </>
  );
};

export default TableUpdate;

const schema = Yup.object().shape({
  saleOpeningEventId: Yup.string().required("Vui lòng chọn đợt mở bán"),
  kRate: Yup.number()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string" && originalValue.trim() === "") {
        return null;
      }
      return Number(originalValue);
    })
    .typeError("Hệ số k phải là một số hợp lệ")
    .moreThan(0, "Hệ số k phải lớn hơn 0")
    .required("Vui lòng nhập hệ số k"),
});

const FormCreateKRateHard = memo(
  ({ isOpen, onClose, onSubmit, defaultValues }) => {
    const {
      register,
      reset,
      handleSubmit,
      formState: { errors },
    } = useForm({
      resolver: yupResolver(schema),
      defaultValues: defaultValues || {},
    });

    useEffect(() => {
      reset(defaultValues);
    }, [isOpen]);

    const [focusStates, setFocusStates] = useState({});

    const handleFocus = (field, index) => {
      setFocusStates((prev) => ({ ...prev, [field]: true }));
    };

    const handleBlur = (field, index) => {
      setFocusStates((prev) => ({ ...prev, [field]: false }));
    };

    const submitHandler = (data) => {
      onSubmit(data);
    };

    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          backgroundColor="var(--color-main)"
          borderRadius={"16px"}
          position={"relative"}
          w={"100%"}
          maxW={"625px"}
        >
          <form onSubmit={handleSubmit(submitHandler)}>
            <Box
              paddingBottom={"80px"}
              h={"400px"}
              w={"100%"}
              overflowY={"scroll"}
              sx={{
                "&::-webkit-scrollbar": {
                  width: "4px",
                },
                "&::-webkit-scrollbar-thumb": {
                  width: "4px",
                  borderRadius: "50px",
                  background: "var(--color-background)",
                },
                "&::-moz-scrollbar": {
                  width: "4px",
                },
                "&::-moz-scrollbar-thumb": {
                  width: "4px",
                  borderRadius: "50px",
                  background: "var(--color-background)",
                },
              }}
            >
              <Flex
                alignItems={"center"}
                p={"25px 24px 24px 24px"}
                position={"relative"}
                borderBottom={"1px solid var(--border-input-employee)"}
              >
                <Text
                  color={"var(--color-header-employee)"}
                  fontSize={"16px"}
                  fontWeight={"600"}
                >
                  Thêm hệ số K tính toán
                </Text>
                <Box
                  position={"absolute"}
                  top={"24px"}
                  right={"24px"}
                  cursor={"pointer"}
                  onClick={onClose}
                >
                  <Image src={IconX} />
                </Box>
              </Flex>
              <Box margin={"0 auto"}>
                <Box p={"24px 40px"}>
                  <Flex mt={"16px"} gap={"27px"}>
                    <InputControl
                      type="number"
                      label="Hệ số k"
                      placeholder="Ví dụ: 1.2 "
                      errors={errors.kRate}
                      register={register("kRate")}
                      onFocus={() => handleFocus("kRate")}
                      onBlur={() => handleBlur("kRate")}
                      state={focusStates["kRate"]}
                      mwidth={"100%"}
                      isRequired={true}
                    />
                  </Flex>
                </Box>
              </Box>
              <Box
                position={"absolute"}
                w={"100%"}
                bottom={"0"}
                bg={"var(--color-main)"}
                borderTop={"0.5px solid var(--bg-line-employee)"}
                borderRadius={"0px 0px 16px 16px"}
                zIndex={3}
              >
                <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
                  <Button
                    w={"112px"}
                    p={"13px 20px"}
                    fontSize={"15px"}
                    fontWeight={600}
                    color={"var(--color-option-employee-hover)"}
                    borderRadius={"8px"}
                    border={"1px solid var(--color-option-employee-hover)"}
                    bg={"var(--color-main)"}
                    _hover={{
                      filter: "brightness(90%)",
                    }}
                    onClick={onClose}
                  >
                    Hủy
                  </Button>
                  <Button
                    type="submit"
                    w={"112px"}
                    p={"13px 20px"}
                    fontSize={"15px"}
                    fontWeight={600}
                    color={"var(--color-main)"}
                    borderRadius={"8px"}
                    bg={"var(--color-option-employee-hover)"}
                    _hover={{
                      filter: "brightness(90%)",
                    }}
                  >
                    Lưu
                  </Button>
                </Flex>
              </Box>
            </Box>
          </form>
        </ModalContent>
      </Modal>
    );
  },
);
